import { constants } from "redux/constants/redux-constants";

export const togglePersistChat = (persist) => ({
  type: constants.CHAT.TOGGLE_PERSIST_CHAT,
  payload: persist,
});
export const set_selected_conversation = (payload) => ({
  type: constants.CHAT.SET_SELECTED_CONVERSATION,
  payload,
});
